import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrganizationMigrationService {
    private http = inject(HttpClient);


    private baseUrl = environment.apiUrl + '/api/v1/organization-migration';

    updateDoNotEnable(organizationId: number, doNotEnable: boolean): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/${organizationId}/do-not-enable`, { doNotEnable });
    }
}

